import "./_nav.css";
import { checkPermission } from "./screens/Config/utils";

export const filterNavItems = () => {
  let navItems = [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
      show: checkPermission("menu", "dashboard"),
    },
    {
      name: "Users",
      url: "/users",
      icon: "icon-user",
      show: checkPermission("menu", "users"),
    },
    {
      name: "My Load Board",
      url: "/loadboard",
      icon: "fa fa-eercast",
      show: checkPermission("menu", "Myloadboard"),
    },
    {
      name: "Trip Design",
      url: "/tripDesign",
      icon: "fa fa-plane",
      show: checkPermission("menu", "tripdesign"),
    },
    {
      name: "Trip Events & Status",
      url: "/tripEvents",
      icon: "fa fa-road",
      show: checkPermission("menu", "tripevents"),
    },
    {
      name: "Completed Loads",
      url: "/completedload",
      icon: "fa fa-check-square-o",
      show: checkPermission("menu", "completeorder"),
    },
    {
      name: "Warehouse Management",
      url: "/mywarehousesubscription",
      icon: "fa fa-home",
      show: checkPermission("menu", "mywarehousesubscription"),
      children: [
        {
          name: "Warehouses",
          url: "/mywarehousesubscription/subscriptionlist",
          icon: "fa fa-support",
          // show: checkPermission("menu", "subsriptnwarehouseothers"),
          show: checkPermission("menu", "usersubsriptnwarehouse"),
        },
        {
          name: "My Subscriptions",
          url: "/mywarehousesubscription/subscriptions",
          icon: "nav-icon fa fa-file",
          show: checkPermission("menu", "mysubscriptionswarehouse"),
        },
      ],
    },
    {
      name: "Warehouse Management",
      url: "/warehouse",
      icon: "fa fa-home",
      show: checkPermission("menu", "warehouse"),
      children: [
        {
          name: "Warehouses",
          url: "/warehouse/warehousemanagement",
          icon: "fa fa-plus",
          show: checkPermission("menu", "warehousemanagement"),
        },
        {
          name: "My Plans",
          url: "/warehouse/warehouseplan",
          icon: "fa fa-file-text-o",
          show: checkPermission("menu", "warehouseplan"),
        },
        {
          name: "Subscriptions",
          url: "/warehouse/warehousesubscriptions",
          icon: "fa fa-file",
          show: checkPermission("menu", "warehousesubscriptions"),
        },
        {
          name: "Warehouse Performance",
          url: "/warehouseperformance",
          icon: "fa fa-tasks",
          show: checkPermission("menu", "warehouseperformance"),
        },
      ],
    },
    {
      name: "Invoice",
      url: "/invoice",
      icon: "fa fa-file-text-o",
      show: checkPermission("menu", "invoice"),
    },
    {
      name: "Invoice",
      url: "/runnerinvoice",
      icon: "fa fa-file-text-o",
      show: checkPermission("menu", "runnerinvoice"),
    },
   
    {
      name: "Payments",
      url: "/payments",
      icon: "fa fa-book",
      show: checkPermission("menu", "payments"),
    },
    {
      name: "Payments",
      url: "/runnerpayments",
      icon: "fa fa-book",
      show: checkPermission("menu", "runnerpayments"),
    },
    {
      name: "Partner Requests",
      url: "/partnerrequests",
      icon: "icon-people",
      show: checkPermission("menu", "partnerrequests"),
    },
    {
      name: "Expense",
      url: "/expense",
      icon: "fa fa-money",
      show: checkPermission("menu", "expense"),
    },
    {
      name: "Shippers",
      url: "/shippers",
      icon: "icon-user",
      show: checkPermission("menu", "shippers"),
    },
    {
      name: "Drivers",
      url: "/drivers",
      icon: "fa fa-id-card-o",
      show: checkPermission("menu", "drivers"),
    },
    {
      name: "My Vehicles",
      url: "/myvehicles",
      icon: "fa fa-truck",
      show: checkPermission("menu", "myvehicles"),
    },
    {
      name: "My Plans",
      url: "/myplan",
      icon: "fa fa-file-text-o",
      show: checkPermission("menu", "myplan"),
    },
    {
      name: "Subscriptions",
      url: "/subscriptions",
      icon: "fa fa-file-text-o",
      show: checkPermission("menu", "subscriptions"),
    },
    {
      name: "My Team",
      url: "/myteam",
      icon: "fa fa-user-plus ",
      show: checkPermission("menu", "myteam"),
    },
    {
      name: "Rate Card",
      url: "/ratecard",
      icon: "fa fa-money",
      show: checkPermission("menu", "ratecard"),
    },
    // {
    //   name: "My Subscription",
    //   url: "/mysubscription",
    //   icon: "icon-user",
    //   show: checkPermission("menu", "mysubscription"),
    // },

    {
      name: "Subscriptions",
      url: "/mysubscription",
      icon: "fa fa-home",
      show: checkPermission("menu", "mysubscription"),
      children: [
        {
          name: "Available Plans",
          url: "/mysubscription/availableplans",
          icon: "fa fa-support",
          show: checkPermission("menu", "availableplans"),
        },
        {
          name: "My Subscriptions",
          url: "/mysubscription/mysubscriptions",
          icon: "nav-icon fa fa-file",
          show: checkPermission("menu", "mysubscriptions"),
        },
      ],
    },
   
    {
      name: "Support Center",
      url: "/supportcenter",
      icon: "icon-envelope",
      show: checkPermission("menu", "supportcenter"),
    },

    {
      name: "Load Metrics",
      url: "/loadMetrics",
      icon: "icon-user",
      show: checkPermission("menu", "loadMetrics"),
    },
    {
      name: "Operating Location",
      url: "/operatingLocation",
      icon: "icon-user",
      show: checkPermission("menu", "operatingLocation"),
    },
    {
      name: "Branding",
      url: "/configuration",
      icon: "fa fa-trademark ",
      show: checkPermission("menu", "branding"),
      children: [
        {
          name: "Invoice Configuration",
          url: "/branding/invoiceConfig",
          icon: "fa fa-paperclip ",
          show: checkPermission("menu", "brandingInvoice"),
        },
      ],
    },
  ];

  let newArray = navItems.filter((x) => {
    let t = x;
    if (t.children) {
      t.children = t.children.filter((child) => child.show);
    }
    return t.show;
  });
  return { items: newArray };
};
